import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';

const translationPrefix = 'kilowhat-wordpress.forum.instant-login.';

export default function () {
    const iframe = document.getElementById('wp-frame-auth') as HTMLIFrameElement;

    // The iframe is created by the backend and injected through a content extender
    // It's placed above the main script tags, so it will exist as soon as Flarum boots
    // If it doesn't exist, it means the conditions for using iframe login were not met
    // and we can safely exit
    if (!iframe) {
        return;
    }

    let pageInitialized = false;

    extend(Page.prototype, 'oninit', function () {
        if (pageInitialized) {
            return;
        }

        pageInitialized = true;

        const wpUrl = new URL(app.forum.attribute('kilowhatWordpressProfileLink'));
        let iframeReplied = false;
        let pingCount = 0;

        window.addEventListener('message', (event) => {
            // We might get multiple replies, we only need 1
            if (iframeReplied) {
                return;
            }

            if (event.origin !== wpUrl.origin) {
                return;
            }

            if (typeof event.data !== 'object' || !event.data.hasOwnProperty('token')) {
                return;
            }

            iframeReplied = true;

            const {token, displayName, avatarUrl} = event.data;

            if (token) {
                const redirectUrl = app.forum.attribute('baseUrl') + '/auth/wordpress?' + m.buildQueryString({
                    return: window.location.href,
                    continue: 1,
                    token,
                });

                const timeRemainingForAutoRedirect = (new Date(iframe.dataset.redirectUntil!)).getTime() - (new Date()).getTime();

                if (app.forum.attribute('debug')) {
                    console.info('[WP Iframe] token available ' + token + ', ms remaining for redirect ' + timeRemainingForAutoRedirect);
                }

                // If under the configured delay, redirect without asking
                if (timeRemainingForAutoRedirect > 0) {
                    window.location.href = redirectUrl;
                    return;
                }

                let loading = false;

                app.alerts.show({
                    type: 'wordpress-instant-login',
                }, [
                    m('.KilowhatWordpressInstantLogin-welcome', displayName ? app.translator.trans(translationPrefix + 'welcome_known_user', {
                        avatar: avatarUrl ? m('img.KilowhatWordpressInstantLogin-avatar', {
                            src: avatarUrl,
                            alt: extractText(app.translator.trans(translationPrefix + 'avatar_alt_text')),
                        }) : null,
                        name: displayName,
                    }) : app.translator.trans(translationPrefix + 'welcome_unknown_user')),
                    m('.KilowhatWordpressInstantLogin-message', app.translator.trans(translationPrefix + 'message')),
                    Button.component({
                        className: 'Button Button--primary KilowhatWordpressInstantLogin-button',
                        onclick() {
                            loading = true;
                            window.location.href = redirectUrl;
                        },
                        loading,
                    }, app.translator.trans(translationPrefix + 'button')),
                ]);
            } else if (app.forum.attribute('debug')) {
                console.info('[WP Iframe] no token');
            }
        });

        const pingIframe = () => {
            if (iframeReplied || pingCount > 20) {
                return;
            }

            pingCount++;

            const {contentWindow} = iframe;

            if (contentWindow) {
                try {
                    contentWindow.postMessage({
                        ready: 1,
                    }, wpUrl.origin);
                } catch (error) {
                    // Silence errors. This will likely happen if the iframe has not finished loading yet
                    if (app.forum.attribute('debug')) {
                        console.warn('[WP Iframe] postMessage failed', error);
                    }
                }
            } else if (app.forum.attribute('debug')) {
                console.warn('[WP Iframe] not available');
            }

            setTimeout(pingIframe, 100);
        };

        pingIframe();
    });
}
